import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import { isSlideComponentCharacter, Question } from '@/types/slide';
import { isCorrectnessDeterminable } from '@/utils/score';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDuration } from '../../format';
import { ResultCardUnsupported } from '../cards/ResultCardUnsupported';
import { ResultContainer, ResultTitle } from '../ResultCard';

import { ResultContentCharacter } from './contents/ResultContentCharacter.legacy';

export const ResultCardCharacter: React.FC<{ question: Question }> = ({ question }) => {
    const { t } = useTranslation();

    // only care the latest answer
    const answer = question.answers[0];
    const scored = !isCorrectnessDeterminable(question) || answer?.correct;
    const timeSpent = formatDuration(question.answers.reduce((total, answer) => total + (new Date(answer.endTime).getTime() - new Date(answer.startTime).getTime()), 0) / 1000);

    if (!isSlideComponentCharacter(question)) {
        return <ResultCardUnsupported question={question} />;
    }

    const type =
        question.content.gameType === 'Writing'
            ? t('slide.legacy.character.type.writing')
            : question.content.gameType === 'OneCard' || question.content.gameType === 'TwoCards'
              ? t('slide.legacy.character.type.card')
              : t('slide.legacy.character.type.recording');
    const caption =
        question.answers.length === 0
            ? t('result.message.noResult')
            : question.content.gameType === 'Writing'
              ? t('result.message.replayStroke')
              : question.content.gameType === 'OneCard' || question.content.gameType === 'TwoCards'
                ? t('result.message.cardCaption')
                : t('result.message.replayRecording');

    return (
        <>
            <ResultContainer>
                <Stack spacing={1}>
                    <Box sx={{ display: 'flex' }}>
                        <ResultTitle variant='h5'>
                            {t('slide.legacy.character.title')} - {type}
                        </ResultTitle>
                        <Box sx={{ flexGrow: 1 }} />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography color={question.answers.length > 0 ? 'text.secondary' : 'text.warning'}>{caption}</Typography>
                        {question.answers.length > 0 && (
                            <Typography color='text.secondary'>
                                {t('result.label.timeSpent')}: {timeSpent}
                            </Typography>
                        )}
                    </Box>
                </Stack>

                <ResultContentCharacter question={question} viewOnly={false} />

                <Box
                    sx={(theme) => ({
                        backgroundColor: !answer ? 'transparent' : scored ? (theme.vars || theme).palette.success.main : (theme.vars || theme).palette.error.main,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        p: 1,
                        borderRadius: '4px',
                    })}
                >
                    {!answer ? (
                        <Typography variant='h5' color='warning' textAlign={'center'}>
                            {t('result.label.noResult')}
                        </Typography>
                    ) : scored ? (
                        <CheckIcon style={{ color: 'white' }} />
                    ) : (
                        <CloseIcon style={{ color: 'white' }} />
                    )}
                </Box>
            </ResultContainer>
        </>
    );
};
